import { render, staticRenderFns } from "./EnableCoverageSteps.vue?vue&type=template&id=31ae6275&scoped=true"
import script from "./EnableCoverageSteps.vue?vue&type=script&lang=ts"
export * from "./EnableCoverageSteps.vue?vue&type=script&lang=ts"
import style0 from "./EnableCoverageSteps.vue?vue&type=style&index=0&id=31ae6275&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_75d14e9340cbf130d0af91897aeb0542/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ae6275",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,UnstyledCopyButton: require('/app/components/UnstyledCopyButton.vue').default,ZStep: require('/app/components/zeal/ZStep/ZStep.vue').default,ZStepper: require('/app/components/zeal/ZStepper/ZStepper.vue').default,ZAccordionItem: require('/app/components/zeal/ZAccordionItem/ZAccordionItem.vue').default,ZAccordion: require('/app/components/zeal/ZAccordion/ZAccordion.vue').default})
